import React from 'react';
import AboutInfo from './subcomponents/AboutInfo';

const About = () => {
    return(
        <AboutInfo/>
    );
}

export default About;